import React from 'react';
import { useTranslation } from 'react-i18next';
import InputFilterItem from '../../../../components/InputFilterItem';
import SingleSelect from '../../../../components/SingleSelect';
import { getSmartLabelClassName } from '../../../../utils/labelWidthUtils';

export interface AbAddressFilterOptions {
  id?: string;
  aAddress?: string;
  bAddress?: string;
  reporterName?: string;
  status?: string;
}

export const DEFAULT_AB_ADDRESS_FILTER_OPTIONS: AbAddressFilterOptions = {
  id: undefined,
  aAddress: undefined,
  bAddress: undefined,
  reporterName: undefined,
  status: undefined,
};

interface AbAddressFilterAreaProps {
  filters: AbAddressFilterOptions;
  setFilters: (filters: AbAddressFilterOptions) => void;
}

// 仅保留数字字符（用于 ID 的严格数字输入）
const digitsOnly = (value: string): string => value.replace(/[^0-9]/g, '');

const AbAddressFilterArea: React.FC<AbAddressFilterAreaProps> = ({ filters, setFilters }) => {
  const { t } = useTranslation();

  const handleChange = (key: keyof AbAddressFilterOptions, value: string | undefined) => {
    const processed = typeof value === 'string' && value.trim() === '' ? undefined : value;
    setFilters({ ...filters, [key]: processed });
  };

  const columnLabels = [
    t('wms.abAddress.filters.id'),
    t('wms.abAddress.filters.aAddress'),
    t('wms.abAddress.filters.bAddress'),
    t('wms.abAddress.filters.reporter'),
    t('wms.abAddress.filters.status'),
  ];
  const labelClassName = getSmartLabelClassName(columnLabels);

  const statusOptions = [
    { label: t('wms.abAddress.status.pending'), value: '0' },
    { label: t('wms.abAddress.status.approved'), value: '1' },
    { label: t('wms.abAddress.status.rejected'), value: '2' },
  ];

  return (
    <div className="mb-2 pl-0 py-2">
      <div className="grid grid-cols-3 gap-x-10 gap-y-4 items-start">
        <div className="min-w-0">
          <InputFilterItem
            label={t('wms.abAddress.filters.id')}
            value={filters.id ?? ''}
            onChange={(e) => handleChange('id', digitsOnly(e.target.value))}
            spanClassName={labelClassName}
            placeholder={t('wms.abAddress.placeholders.id') as string}
          />
        </div>
        <div className="min-w-0">
          <InputFilterItem
            label={t('wms.abAddress.filters.aAddress')}
            value={filters.aAddress ?? ''}
            onChange={(e) => handleChange('aAddress', e.target.value)}
            spanClassName={labelClassName}
            placeholder={t('wms.abAddress.placeholders.aAddressFuzzy') as string}
          />
        </div>
        <div className="min-w-0">
          <InputFilterItem
            label={t('wms.abAddress.filters.bAddress')}
            value={filters.bAddress ?? ''}
            onChange={(e) => handleChange('bAddress', e.target.value)}
            spanClassName={labelClassName}
            placeholder={t('wms.abAddress.placeholders.bAddressFuzzy') as string}
          />
        </div>
        <div className="min-w-0">
          <InputFilterItem
            label={t('wms.abAddress.filters.reporter')}
            value={filters.reporterName ?? ''}
            onChange={(e) => handleChange('reporterName', e.target.value)}
            spanClassName={labelClassName}
            placeholder={t('wms.abAddress.placeholders.reporter') as string}
          />
        </div>
        <div className="min-w-0">
          <SingleSelect
            label={t('wms.abAddress.filters.status')}
            options={statusOptions}
            value={filters.status}
            onChange={(v) => handleChange('status', v)}
            spanClassName={labelClassName}
            allowClear
          />
        </div>
      </div>
    </div>
  );
};

export default AbAddressFilterArea;
